module.exports = __webpack_public_path__ + "img/down-anhui1.0bb61f10.jpg";